import React from "react";
import ProductSideService from "./ProductSideService";
import BgImg from "../../assets/portfolio/bg2.png";
import OurClients from "../OurClients/OurClients";
import LeadManagemnt from "../../assets/product/Lead-Management-System-png.png";
import LEADHERO from "../../assets/product/LMS-Hero.png";
import {
  faUserCheck,
  faEnvelopeOpen,
  faHandshake,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LeadsManagementSystem = () => {
  const pillars = [
    {
      title: "Lead Generation",
      description:
        "Attract potential customers through marketing tactics like content and social media.",
      icon: faUserCheck,
      bgColor: "bg-blue-100",
    },
    {
      title: "Lead Nurturing",
      description:
        "Engage leads with personalized follow-ups to build trust and move them through the funnel.",
      icon: faEnvelopeOpen,
      bgColor: "bg-green-100",
    },
    {
      title: "Lead Scoring & Qualification",
      description:
        "Evaluate and prioritize leads based on engagement to focus on high-potential prospects.",
      icon: faHandshake,
      bgColor: "bg-yellow-100",
    },
    {
      title: "Lead Conversion",
      description:
        "Close deals by addressing objections and providing the information needed for purchasing.",
      icon: faUsers,
      bgColor: "bg-red-100",
    },
  ];

  return (
    <div>
      {/* Hero section */}
      <div className="relative bg-gradient-to-r from-[#0B0F2F] to-[#12164E] text-white py-10 px-4 md:px-8 lg:px-8 overflow-hidden">
        {/* Decorative Background Circles */}
        <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-blue-500 opacity-30 rounded-full blur-3xl z-0" />
        <div className="absolute bottom-[-150px] right-[-100px] w-[400px] h-[400px] bg-main1  opacity-20 rounded-full blur-3xl z-0" />

        <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Text Content */}
          <div>
            <h1 className="text-2xl md:text-4xl lg:text-4xl font-bold leading-tight text-[#8cd3fe]">
              Leads Management System
            </h1>
            <p className="md:mt-6 mt-4 text-gray-300 text-[15px] md:text-lg">
              The Lead Management System helps businesses track and manage
              potential customers, ensuring no opportunity is missed. It
              captures lead data, qualifies them, and assigns them to the
              appropriate sales rep for follow-up. By streamlining this process,
              businesses can improve conversion rates, enhance customer
              relationships, and increase sales efficiency.
            </p>
            <button className="hidden md:block mt-8 px-6 py-3 rounded-full bg-main1 hover:bg-[#1c7ed6] text-white font-medium transition">
              Know More
            </button>
          </div>

          {/* Right Image/Graphic Content */}
          <div className="flex justify-center items-center">
            <img
              src={LEADHERO}
              alt="Lead-management-system"
              className="w-full max-w-md md:max-w-md lg:max-w-md"
            />
          </div>
        </div>
      </div>
      <div className="md:py-5  py-1 ">
        <h2 className="text-xl px-2 md:px-0 md:text-3xl font-semibold text-center mt-4 mb-2 text-gray-600">
          Leads Management System
        </h2>
        <div className="md:w-40 w-24 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />

        <p className="text-center text-sm md:text-base text-gray-700 px-4 md:px-20 lg:px-40">
          Efficiently capture, track, and convert leads into loyal customers,
          boosting sales and enhancing business growth.
        </p>

        {/* Wrapper that allows scrolling */}
        <div className="  md:px-5 sm:px-3 grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-3 sm:gap-2 md:gap-8">
          {/* Main Content */}

          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
              {/* Image Section */}

              <div className="w-full md:order-1 order-2 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <img
                  src={LeadManagemnt}
                  alt="Lead-Management"
                  className="w-full h-full  object-contain"
                />
              </div>

              {/* Text Content Section */}
              <div className="space-y-4 md:text-base  text-sm order-2 md:order-1 text-justify">
                <p className="text-gray-700  md:text-base  text-sm ">
                  We provide the services to manage a good lead management
                  system which ensures that every lead is automatically fed into
                  the system from web forms, emails, and chat, preventing leads
                  from falling through the cracks.
                </p>
                <div>
                  <div className=" py-2">
                    <h2 className="md:text-xl text-lg font-semibold text-main">
                      Lead Generation
                    </h2>
                    <p className="text-justify md:text-base  text-sm ">
                      Businesses create consumer interest and inquiry into
                      products or services through a range of marketing tactics,
                      including blog posts, advertisements, social media,
                      events, and PR campaigns.
                    </p>
                  </div>
                  <div className=" py-2">
                    <h2 className="md:text-xl text-lg font-semibold text-main">
                      Customer Inquiry and Capture
                    </h2>
                    <p className="text-justify md:text-base  text-sm ">
                      Consumers of marketing respond with interest, and their
                      data is recorded, creating a sales lead.
                    </p>
                  </div>

                  <div className=" py-1">
                    <h2 className="md:text-xl text-lg font-semibold text-main">
                      Filtering, Grading, Distribution, and Contact
                    </h2>
                    <p className="text-justify md:text-base  text-sm ">
                      Leads are sorted by validity, prioritized based on
                      likelihood of becoming a customer, and dispersed to sales
                      reps to be contacted.
                    </p>
                  </div>
                  <div className=" py-1">
                    <h2 className="md:text-xl text-lg font-semibold text-main">
                      Lead Nurturing
                    </h2>
                    <p className="text-justify md:text-base  text-sm ">
                      Leads are sorted by contacted or uncontacted and scheduled
                      for follow-ups. They may be put into drip-marketing
                      campaigns or followed-up on the phone by a company rep.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sticky Sidebar */}
          <div className="sticky  top-20 self-start  p-3  h-fit">
            <ProductSideService />
          </div>
        </div>
      </div>

      <div
        className="py-5 px-5 relative"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "60vh",
        }}
      >
        <div className="text-center py-10 px-4">
          <h2 className="text-2xl md:text-4xl font-semibold">
            <span className="text-black"> Features OF Lead </span>
            <span className="text-sky-500"> Management System</span>
          </h2>

          <div className="relative w-fit mx-auto mt-2">
            <div className="h-[1px] bg-gray-300 md:w-[200px] w-[100px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>

          <p className="text-gray-500 text-base mt-4">
            What You Get Using Our Inventory Management System
          </p>
        </div>

        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {pillars.map((pillar, index) => (
              <div
                key={index}
                className="bg-gray-50 shadow-md  overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <div className="p-8 text-center">
                  <div
                    className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                  >
                    <FontAwesomeIcon
                      icon={pillar.icon}
                      className="text-sky-500 text-2xl"
                    />
                  </div>
                  <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                    {pillar.title}
                  </h5>
                  <p className="text-gray-600 text-sm">{pillar.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* client section */}
      <div>
        <OurClients />
      </div>
    </div>
  );
};

export default LeadsManagementSystem;
